import { LoyaltyModel } from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsModel";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get } from "@insite/client-framework/Services/ApiService";
export interface BatchgetCustomParameter extends ApiParameter {
    extendedNames: string[];
}
const getStatuscallUri = "/api/v1/getcustomerstatus";
export const getStatuscall = async () => {
    try {
        const response = await get<ServiceResult<any[]>>(`${getStatuscallUri}`);
        return {
            response: response,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};
